import { html, render } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { translate } from "@escapio/shared/l10n/translate";
import checkmarkSvg from "@docroot/public/img/linearicons/checkmark.svg";
import "./Validator";

class NewsletterForm extends HTMLElement {
	connectedCallback() {
		const template = html`
			<esc-newsletter-validator one-time-submit location=${this.location}>
				<form
					method="POST"
					action="/newsletter/customer"
					class="newsletter-form"
				>
					<input type="hidden" name="source" value=${this.location} />

					<div class="form-validated__input-container">
						<label class="form-validated__label">
							<input
								type="email"
								name="email"
								value=""
								placeholder=" "
								aria-label=${translate("newsletter_form_email_placeholder")}
							/>
							<span class="form-validated__label__text"
								>${translate("newsletter_form_email_placeholder")}</span
							>
						</label>
						<span
							data-form-field-error
							class="form-validated__error ${classMap({
								"form-validated__error--inverse":
									this.hasAttribute("inverse-error"),
							})}"
						></span>
					</div>

					<button
						class="action-button action-button--loader action-button--left-edge"
					>
						${translate("basic_send")}
					</button>

					<div
						data-form-error-message
						class="hidden message
							${classMap({
							"message--colored": this.hasAttribute("colored-message"),
						})}
					"
					>
						<span class="fa fa-info bullit bullit--blue message__icon"></span>
						<span data-form-error-text-node></span>
					</div>
				</form>
				<div
					data-form-success-message
					class="hidden message message--success
						${classMap({
						"message--colored": this.hasAttribute("colored-message"),
					})}
				"
				>
					<span class="bullit bullit--green message__icon"
						>${checkmarkSvg}</span
					>
					<span class="hidden-tablet hidden-desktop hidden-cinema">
						${translate("newsletter_registration_success")}
					</span>
					<span class="hidden-mobile"
						>${translate("newsletter_registration_success_long")}</span
					>
				</div>
			</esc-newsletter-validator>
		`;
		render(template, this, { host: this });
	}

	get location() {
		return this.getAttribute("location") || undefined;
	}
}
customElements.define("esc-newsletter-form", NewsletterForm);
